import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { usePmsTheme } from "../Components/PmsThemeContext";
import { resolveGlobalSettingsEntryPath } from "../utils/moduleEntryResolver";
import { readStoredUser } from "../utils/sessionUser";
import Settings from "./Settings";
import CorporateUserDelegation from "./CorporateUserDelegation";
import { canAccessCorporatePurchasing } from "../corporate-purchasing/corporatePurchasingAccess";
import { roleEditorText } from "./roleEditorMessages";

export default function GlobalUsersRoles({ embedded = false }) {
  const [user, setUser] = useState(() => readStoredUser());
  useEffect(() => {
    const syncUser = () => setUser(readStoredUser());
    window.addEventListener("palantir-session-updated", syncUser);
    window.addEventListener("storage", syncUser);
    return () => {
      window.removeEventListener("palantir-session-updated", syncUser);
      window.removeEventListener("storage", syncUser);
    };
  }, []);
  const { languageId, themeId } = usePmsTheme();
  const t = (text) => roleEditorText(languageId, text);
  const canViewUsersRoles = (Number(user?.id) === 1 || user?.permissions?.["hotel_settings.view_users_tab"] === true) && resolveGlobalSettingsEntryPath(user?.permissions, {
    isAdmin: Number(user?.id) === 1,
  });

  if (!canViewUsersRoles && !canAccessCorporatePurchasing(user)) return <Navigate to="/select-module" replace />;

  const content = canViewUsersRoles
    ? <Settings forcedTab="users" />
    : <CorporateUserDelegation languageId={languageId} themeId={themeId} />;
  if (embedded) return content;

  return (
    <main style={{ padding: "20px", minHeight: "100vh" }}>
      <header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "12px",
          marginBottom: "20px",
        }}
      >
        <strong>{t("Global settings")}</strong>
        <nav aria-label={t("Global navigation")}>
          <Link to="/select-module" className="btn btn-outline-secondary me-2">
            {t("Modules")}
          </Link>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => {
              localStorage.removeItem("palantir_token");
              localStorage.removeItem("palantir_user");
              window.location.href = "/";
            }}
          >
            {t("Logout")}
          </button>
        </nav>
      </header>
      {content}
    </main>
  );
}
